// src/components/IngestionTypeTag.jsx
//
// INGESTION-HISTORY-S1 — small tinted chip for ingestion source type.
// Three variants: csv (blue), file (purple), integration (teal).
//
// Style guide: §25 "Ingestion type tag" (docs/style-guide-components.html).
//
// Usage:
//   <IngestionTypeTag type="csv" />
//   <IngestionTypeTag type="file" />
//   <IngestionTypeTag type="integration" />

import React from "react";
import { T } from "../app/tokens.js";

// Accent tints per type — blue / purple / teal, following existing token pairs.
const TYPE_CONFIG = {
  csv: {
    label:   "CSV",
    bg:      T.blueSoft,
    color:   T.blueDeep,
  },
  file: {
    label:   "FILE",
    bg:      T.purpleBg,
    color:   T.purpleDeep,
  },
  integration: {
    label:   "INTG",
    bg:      T.tealSoftBg,
    color:   T.tealDarkFg,
  },
};

const FALLBACK = { label: "—", bg: T.lightGray, color: T.mid };

/**
 * @param {{ type: 'csv'|'file'|'integration', style?: React.CSSProperties }} props
 */
export function IngestionTypeTag({ type, style }) {
  const cfg = TYPE_CONFIG[type] || FALLBACK;
  return (
    <span
      data-testid={`ingestion-type-tag-${type}`}
      style={{
        display:       "inline-flex",
        alignItems:    "center",
        fontSize:      T.fsXs,
        fontWeight:    T.fwSemibold,
        letterSpacing: "0.04em",
        padding:       "2px 10px",
        borderRadius:  6,
        background:    cfg.bg,
        color:         cfg.color,
        whiteSpace:    "nowrap",
        ...style,
      }}
    >
      {cfg.label}
    </span>
  );
}
